import presenter from './loadable';

export default presenter;
